export default __webpack_public_path__ + "static/media/bootstrap.19a2d2ff.svg";